import workletUrl from './worklet?worker&url';
import type { OdfBand } from '../dsp/types';
import type { WorkletCommand, WorkletMessage } from './messages';

export interface OdfNode {
  readonly node: AudioWorkletNode;
  onMessage(listener: (m: WorkletMessage) => void): () => void;
  send(command: WorkletCommand, transfer?: Transferable[]): void;
  destroy(): void;
}

export async function createOdfNode(context: AudioContext, source: AudioNode, band: OdfBand): Promise<OdfNode> {
  await context.audioWorklet.addModule(workletUrl);
  const node = new AudioWorkletNode(context, 'odf-processor', {
    numberOfInputs: 1,
    numberOfOutputs: 1,
    outputChannelCount: [1],
    channelCount: 1,
    channelCountMode: 'explicit',
    processorOptions: { band },
  });
  node.onprocessorerror = (e) => console.error('odf-processor selhal', e);
  source.connect(node);
  // Výstup je ticho. Uzel bez cesty k destination některé prohlížeče nezpracovávají.
  node.connect(context.destination);

  const listeners = new Set<(m: WorkletMessage) => void>();
  node.port.onmessage = (e: MessageEvent<WorkletMessage>) => {
    for (const l of listeners) l(e.data);
  };

  return {
    node,
    onMessage(listener) {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    send(command, transfer = []) {
      node.port.postMessage(command, transfer);
    },
    destroy() {
      source.disconnect(node);
      node.disconnect();
      node.port.close();
      listeners.clear();
    },
  };
}
